import { Component, OnInit } from '@angular/core';
import { DpSectionForm } from '@docpath/webcomponents';

import { SelfMaintenance } from './models/self-maintenance';
import { SelfMaintenanceFormService } from './services/self-maintenance-form.service';
import { SelfMaintenanceHttpService } from './services/self-maintenance-http.service';

@Component({
    selector: 'app-configuration-self-maintenance',
    templateUrl: './self-maintenance.component.html'
})
export class SelfMaintenanceComponent implements OnInit {
    
    sectionForm: DpSectionForm;

    constructor(
        private readonly selfMaintenanceHttpService: SelfMaintenanceHttpService,
        private readonly selfMaintenanceFormService: SelfMaintenanceFormService
    ) {
        this.sectionForm = this.selfMaintenanceFormService.getSectionForm();
    }

    ngOnInit(): void {

        this.selfMaintenanceHttpService.getSelfMaintenanceConfig().subscribe(config => {
            this.sectionForm.setValue({config});
        });

    }

    submitForm() {

        const config = this.sectionForm.formGroup?.value.config;
        const modifiedMaintenance = new SelfMaintenance(
            config.enable,
            config.startMaintenance,
            config.enableRemoveLogs,
            config.daysKeepLogs,
            config.enableRemoveData,
            config.daysKeepData,
            config.enableRemoveJobs,
            config.daysKeepJobs);

        this.selfMaintenanceHttpService.updateSelfMaintenanceConfig(modifiedMaintenance).subscribe(() => {
            this.sectionForm.setValue({config: modifiedMaintenance});
        });

    }

}